{
  "pt": {
    "marketplace_partner": {
      "contact_me": {
        "button": "Contacte-me!",
        "failure": "Ocorreu um erro inesperado.",
        "success": "Entraremos em contacto consigo brevemente."
      }
    }
  }
}
